export type State = {
  visible: boolean;
};

export const getInitialState = (): State => ({
  visible: false
});
